import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import {
    SearchScopeKind,
    PrimaryMailboxSearchScope,
    ArchiveMailboxSearchScope,
} from 'owa-search-service';
import {
    isFavoritesSearchFolderScenario,
    TableQuery,
    TableQueryType,
    MailFolderTableQuery,
} from 'owa-mail-list-store';
import { getStore as getMailSearchStore } from 'owa-mail-search';
import {
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
} from 'owa-folders';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function shouldShowFolderTag(tableQuery: TableQuery): boolean {
    const { staticSearchScope } = getMailSearchStore();

    // Only show folder tags if user is searching a root folder (in inbox or archive mailbox)
    if (tableQuery.type === TableQueryType.Search && staticSearchScope) {
        const { kind, folderId } = staticSearchScope as
            | PrimaryMailboxSearchScope
            | ArchiveMailboxSearchScope;
        return (
            (kind === SearchScopeKind.PrimaryMailbox &&
                folderId === folderNameToId(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID)) ||
            (kind === SearchScopeKind.ArchiveMailbox &&
                folderId === folderNameToId(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID))
        );
        // ... or if user is in a persona or category folder (in conversation view if 'tri-conversationView-folderTags' flag is turned on or if user is in item view)
    } else if (
        tableQuery.type === TableQueryType.Folder &&
        (tableQuery.listViewType === ReactListViewType.Message ||
            isFeatureEnabled('tri-conversationView-folderTags'))
    ) {
        const { scenarioType } = tableQuery as MailFolderTableQuery;
        return isFavoritesSearchFolderScenario(scenarioType);
    }

    return false;
}
